import script from "./SkillPreviewComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SkillPreviewComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SkillPreviewComponent.vue?vue&type=style&index=0&id=3ad16cc0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ad16cc0"]])

export default __exports__